import { ManageSubscription } from "apiEndPoints";
import APIrequest from "services/axios";
import { logger } from "utils";

export const AdminManageSubscriptionService = {
  getSubscriptionList: async (queryParams) => {
    try {
      const payload = {
        ...ManageSubscription.getAllSubscription,
        queryParams,
      };
      return await APIrequest(payload);
    } catch (err) {
      logger(err);
    }
  },

  getAdminSubscriptionList: async (queryParams) => {
    try {
      const payload = {
        ...ManageSubscription.getAdminSubscription,
        queryParams,
      };
      return await APIrequest(payload);
    } catch (err) {
      logger(err);
    }
  },
  updateSubscription: async ({ id, bodyData }) => {
    try {
      const payload = {
        ...ManageSubscription.updateSubscription(id),
        bodyData,
      };
      return await APIrequest(payload);
    } catch (err) {
      logger(err);
    }
  },

  getPackageList: async ({ queryParams }) => {
    try {
      const payload = {
        ...ManageSubscription.getAllPackage,
        queryParams,
      };
      return await APIrequest(payload);
    } catch (err) {
      logger(err);
    }
  },

  updatePackage: async ({ id, bodyData }) => {
    try {
      const payload = {
        ...ManageSubscription.updatePackage(id),
        bodyData,
      };
      return await APIrequest(payload);
    } catch (err) {
      logger(err);
    }
  },
  updatePackageStatusService: async ({ bodyData, id }) => {
    try {
      const payload = {
        ...ManageSubscription.updatePackageStatus(id),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  updatePaymentStatusService: async (queryParams, id) => {
    try {
      const payload = {
        ...ManageSubscription.updatePayment(id),
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  updateSubscriptionStatusService: async ({ bodyData, id }) => {
    try {
      const payload = {
        ...ManageSubscription.updateSubscriptionStatus(id),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
};
